module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Rose_TW.b189f89b.png";